import React, { Suspense } from 'react';
import Spinner from '../loaders/spinner';

const SuspenseWrapper = ({ children }) => {
  return <Suspense fallback={<Spinner addBg fixed />}>{children}</Suspense>;
};

export default SuspenseWrapper;
